import styled from 'styled-components';
import appStoreButton from '../Placeholder/app-store-white.png';
import * as React from 'react';

export const LeftSection = styled.div`
  min-width: 250px;
  max-width: 300px;
  flex: 0;
  display: flex;
  align-items: center;
`;

export const CentralSection = styled.div`
  flex: 1;
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const RightSection = styled.div`
  display: flex;
  min-width: 200px;
  flex: 0;
  align-items: center;
  justify-content: flex-end;
`;

export const HeaderContainer = styled.header`
  height: ${p => p.theme.sizes.headerHeight};
  min-height: ${p => p.theme.sizes.headerHeight};
  align-items: stretch;
  background-color: ${p => p.theme.color.white};
  border-bottom: 1px solid ${p => p.theme.color.lightGrey};
  display: flex;
  justify-content: space-between;
  padding: 0 1.25em;
`;

const StyledMacAppLink = styled.a`
  margin-right: 20px;
`;

export const MacAppLink = () => {
  const isMac = navigator.platform.indexOf('Mac') > -1;
  if (isMac) {
    return (
      <StyledMacAppLink href="https://apps.apple.com/ua/app/morning-pages-daily-journal/id1223874080" target="_blank">
        <img src={appStoreButton} alt="AppStore" width={120} height={40} />
      </StyledMacAppLink>
    );
  }

  return null;
};



// WEBPACK FOOTER //
// ./src/components/Header/index.tsx